// @flow

import React from 'react';

const Sending = ({ translate } : { translate: any }) => (
  <div className="reminder--body reminder--spinner">
    <h3 className='title-spin'>{translate('reminder.sending')}</h3>
    <div className="caught-rotate">
      <ul className="icons reminder--white">
        <li className="active"><i className="ico reminder--ico ico-4"></i></li>
      </ul>
    </div>
  </div>
);

export default Sending;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/reminder/sending.js